import { z } from 'zod';
import { statusIdSchema, uuidSchema, dateSchema, MAX_NAME_LENGTH, } from './common.js';
/**
 * Base schema for price book fields (without refinements).
 * Used for partial updates and as a building block.
 *
 * `external_system` and `external_system_record_id` are real DB columns
 * that the original schema didn't model — without them and without
 * `.passthrough()`, payloads carrying those fields silently dropped
 * them before reaching the DB (same Phase 1.5 silent-strip class as
 * vendorSchema). Both are nullable+optional strings to match column
 * types; `.passthrough()` is belt-and-braces for any future column
 * we miss.
 */
export const priceBookBaseSchema = z.object({
    name: z
        .string()
        .trim()
        .min(1, 'Name is required')
        .max(MAX_NAME_LENGTH, `Name must be ${MAX_NAME_LENGTH} characters or less`),
    vendor_id: uuidSchema,
    effective_date: dateSchema,
    expiry_date: dateSchema.optional().or(z.literal('')).nullable(),
    region_id: uuidSchema.optional().nullable(),
    segment_id: uuidSchema.optional().nullable(),
    // Status is now managed via status_id foreign key
    status_id: statusIdSchema,
    external_system: z.string().nullable().optional(),
    external_system_record_id: z.string().nullable().optional(),
}).passthrough();
/**
 * Schema for creating a new price book.
 */
export const priceBookCreateSchema = priceBookBaseSchema.refine((data) => {
    if (!data.expiry_date || data.expiry_date === '')
        return true;
    return new Date(data.expiry_date) >= new Date(data.effective_date);
}, {
    message: 'Expiry date must be on or after effective date',
    path: ['expiry_date'],
});
/**
 * Schema for updating an existing price book.
 * All fields are optional for partial updates.
 */
export const priceBookUpdateSchema = priceBookBaseSchema.partial();
//# sourceMappingURL=priceBookSchema.js.map